import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker ,Modal  } from 'antd';


import attached from '../../assets/images/icon/paperclip.png';
import music from '../../assets/images/icon/music.png';
import pdf_ from '../../assets/images/icon/pdf_.png';
import image from '../../assets/images/icon/image.png';
import person from '../../assets/images/icon/person.png';
import correct from '../../assets/images/icon/correct.png';
import wrong from '../../assets/images/icon/wrong.png';
import edit from '../../assets/images/icon/edit.png';
import next from '../../assets/images/icon/next.png';
import fee from '../../assets/images/icon/fee.png';
import breakfast from '../../assets/images/icon/breakfast.png';
import microscope from '../../assets/images/icon/microscope.png';
import abc from '../../assets/images/icon/abc.png';
import stars from '../../assets/images/icon/stars.png';
import diary from '../../assets/images/icon/diary.png';
import promotion from '../../assets/images/icon/promotion.png';
import playbutton from '../../assets/images/icon/play-button.png';


const { Panel } = Collapse;
const { Search } = Input;
const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}

function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			size: 'default',
			quant: 'default',
			like: 'default',
			comment: 'default',
			notification: 'default',
			value: '',
			
			loading: false,
			visible: false,
		}
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
	}
	
	hide = () => {
    this.setState({
      visible: false,
    });
  };
  
  handleVisibleChange = visible => {
    this.setState({ visible });
  };
	
	handleSizeChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };
  
  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = () => {
    this.setState({ loading: true });
    setTimeout(() => {
      this.setState({ loading: false, visible: false });
    }, 3000);
  };

  handleCancel = () => {
    this.setState({ visible: false });
  };

	render()

	{
	
	const { size } = this.state;
	  const { visible, loading } = this.state;			
					
		return (
			<div class="mobile_view">
			
			<div id="main" class="bg-off">
         <div class="row">
		 
		  <div class="col s12 m12 ex-padd">
            <div id="breadcrumbs-wrapper" class="bg-off">
               <div class="">
                  <div class="row no-margin">
				  <div class="col s12 m12 header-title mt-20 mh-40 iq-card">
					<div class="col s12 m6 l6 pb-15 mt-5">
                        <h5 class="breadcrumbs-title"><span class="back_arrow" onClick={this.context.router.history.goBack}><i class="ri-arrow-left-circle-line"></i></span><span class="main_title">Help Video</span></h5>
                     </div>
                     
                     <div class="col s12 m6 l6 right-align-md pt-10">
                          <ol class="breadcrumbs mb-0">
                           <li class="breadcrumb-item"><a href="/">Home</a>
                           </li>
						   
						  
                           <li class="breadcrumb-item active">Help Video
                           </li>
                        </ol>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
            </div>
            

		  <div class="col s12 m12 ex-padd">
            <div class="container view-Profile viewprograms view-Profile-mobile">
			   <div class="col s12 m12 mb-20 card-content iq-card">
                  <section class="invoice-list-wrapper section food ">
					
					<div class="children bg-blue communication mb-20 iq-card2 faq flow-root">
                    
							<div class="children bg-blue video  pt-10">
								
								<div class="col m12 s12 mb-10 bb pb-10">
									<Link to={`${process.env.PUBLIC_URL}/help-video/view-video`}>
										<div class="col m12 s12 no-padd">
											<img src={playbutton} class="video-img"/>
											 Benefits of kidzonia Preschool App 
										</div>
									</Link>
								</div>
								<div class="col m12 s12 mb-10 bb pb-10">
									<Link to={`${process.env.PUBLIC_URL}/help-video/view-video`}>
										<div class="col m12 s12 no-padd">
											<img src={playbutton} class="video-img"/>
											  Benefits of kidzonia for Parents App  
										</div>
									</Link>
								</div>
								<div class="col m12 s12 mb-10 bb pb-10">
									<Link to={`${process.env.PUBLIC_URL}/help-video/view-video`}>
										<div class="col m12 s12 no-padd">
											<img src={playbutton} class="video-img"/>
											  How is kidzonia App Useful for Parents  
										</div>
									</Link>
								</div>
								<div class="col m12 s12 mb-10 bb pb-10">
									<Link to={`${process.env.PUBLIC_URL}/help-video/view-video`}>
										<div class="col m12 s12 no-padd">
											<img src={playbutton} class="video-img"/>
											  Enquiries Management 
										</div>
									</Link>
								</div>
								<div class="col m12 s12 mb-10 bb pb-10">
									<Link to={`${process.env.PUBLIC_URL}/help-video/view-video`}>
										<div class="col m12 s12 no-padd">
											<img src={playbutton} class="video-img"/>
											  Add/Edit Enquiry Labels 
										</div>
									</Link>
								</div>
								<div class="col m12 s12 bb pb-10">
									<Link to={`${process.env.PUBLIC_URL}/help-video/view-video`}>
										<div class="col m12 s12 no-padd">
											<img src={playbutton} class="video-img"/>
											  Setup Programs 
										</div>
									</Link>
								</div>
								
								
							</div>
								
								
					</div>	
							
						
					

								
					
					
					
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
            </div>
         </div>
      </div>
     
			</div>
		) 
	} 
}
export default Index;
